import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {ChoiceButton, DialogsService, FormService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {CartService, FormApplication} from '../../../shared/services/cart.service';
import {Direction, FormField, FormStep, VisaFN, VisaFormName} from '../../../shared/models/forms';
import {RequestService} from '../../../shared/services/request.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  CardPayment,
  CurrencySign,
  IveriCards,
  PaypalCards,
  Request,
  RequestMNTAType,
  RequestState,
  ZimSwitchCards
} from '../../../shared/models/request';
import {FormError} from 'ngx-satoris/lib/shared/models/forms';
import {InactivityService} from '../../../shared/services/inactivity.service';
import {DocumentType, UserPermission} from '../../../shared/models/user';
import {ScanDocumentService} from 'src/app/shared/services/scan-document.service';
import {PaymentService} from 'src/app/shared/services/payment.service';
import {PlacesService} from '../../../shared/services/places.service';
import {isCanHaveOnArrival, isPortOnlinePayable, setCurrentCountryCat, showWarning} from 'src/app/shared/models/default-filter-strategy';
import {DialogBookTimeSlotComponent} from 'src/app/components/dialogs/dialog-book-time-slot/dialog-book-time-slot.component';
import {Payment} from 'src/app/shared/models/payment';

declare const window: any;

@Component({
  selector: 'app-5.summary',
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SummaryComponent {

  currentApplication: FormApplication;
  subscription: any;
  form: FormGroup;
  keepScanned = false;
  showModalityMessage: boolean;
  submitted: boolean;
  disabledConfirm: boolean;
  showPayOnline: boolean;
  disclaimerOpen = false;
  localCard: boolean;
  choiceButtons: ChoiceButton[] = [
    {text: 'global.Yes', value: 'true', backgroundColor: 'var(--clr-lt)', textColor: 'var(--clr-dk)', opacity: '0.7', selected: {backgroundColor: '#6fb76b', textColor: 'var(--clr-lt)', opacity: '1'}},
    {text: 'global.No', value: 'false', backgroundColor: 'var(--clr-lt)', textColor: 'var(--clr-dk)', opacity: '0.7', selected: {backgroundColor: 'var(--clr-btn-red)', textColor: 'var(--clr-lt)', opacity: '1'}}
  ];
  showWarning = showWarning;
  paymentMethods: CardPayment[] = [];
  isPortOnlinePayable = isPortOnlinePayable;

  constructor(public api: ApiService,
    public nav: NavigateService,
    public cart: CartService,
    public request: RequestService,
    public forms: FormService,
    public places: PlacesService,
    private dialog: DialogsService,
    private formBuilder: FormBuilder,
    private inactivity: InactivityService,
    private lang: LangService,
    private loader: LoaderService,
    private scanDoc: ScanDocumentService,
    private payment: PaymentService) {
    const webKiosk = sessionStorage.getItem('webKiosk') === 'true';
    this.subscription = this.cart.currentApplication$.subscribe(() => {
      if(!this.cart.currentRequest) {
        if((this.api.userRole.isWorker && this.api.hasPerm(UserPermission.ALLOW_CREATE) && this.api.hasPerm(UserPermission.ALLOW_CONSUME))) {
          this.nav.to('dashboard');
        } else if(this.api.userRole.isKiosk && !webKiosk) {
          this.nav.to('standby-kiosk');
        } else if(this.api.env.formHasTravelNameStep) {
          this.nav.to('travel-name');
        } else if(this.api.env.hasMultiPersonView) {
          this.nav.to('participants');
        }
      } else if(!this.cart.allPersonRequestsAreValid()) {
        if(this.cart.currentRequest?.latestRouteVisited) {
          this.nav.to(this.cart.currentRequest.latestRouteVisited);
        } else if(this.api.env.formHasTravelNameStep) {
          this.nav.to('travel-name');
        } else if(this.api.env.hasMultiPersonView) {
          this.nav.to('participants');
        } else {
          this.nav.to('dashboard');
        }
      }
      this.currentApplication = this.cart.currentApplication;
      this.cart.currentRequest = {...this.cart.currentRequest, latestRouteVisited: 'summary'};
      this.cart.saveCurrentApplication(false);
      this.showPayOnline = this.currentApplication.isExtend ? false :
        this.currentApplication.requests.some(request => this.getPrice(request, true) && !this.request.isPaidOnline(request.visaType.id, request.metadata, request));
      this.setForm();
      this.showModalityMessage = true;

    });
    if(!this.inactivity.isWatching && this.api.userRole.isKiosk) this.inactivity.startWatching();
  }

  ngOnInit() {
    this.getSupportedPayments();
    if(this.api.userRole.isCustomer) {
      this.request.invalidatePersons = this.cart.currentApplication.requests.map(request => request.person);
      this.payment.getRequestData(this.request.invalidatePersons).then(() => {
        this.detectIfDraftPayments();
      });
    }
  }

  ngOnDestroy() {
    if(!this.keepScanned) {
      this.scanDoc.scanned = false;
    }
    this.subscription.unsubscribe();
  }

  getSupportedPayments() {
    //filter the supportedPayments array based on the supportedPaymentProviders array
    this.api.env.supportedPaymentProviders.forEach((provider: RequestMNTAType) => {
      switch(provider) {
      case RequestMNTAType.PAYPAL:
        this.paymentMethods = this.paymentMethods.concat(Object.values(PaypalCards).filter(payment => this.api.env.supportedPayments.includes(payment)));
        break;
      case RequestMNTAType.IVERI:
        this.paymentMethods = this.paymentMethods.concat(Object.values(IveriCards).filter(payment => this.api.env.supportedPayments.includes(payment)));
        break;
      case RequestMNTAType.ZIMSWITCH:
        this.paymentMethods = this.paymentMethods.concat(Object.values(ZimSwitchCards).filter(payment => this.api.env.supportedPayments.includes(payment)));
        break;
      }
    });
  }

  setForm() {
    this.form = this.formBuilder.group({});
    this.currentApplication.requests.forEach((_request, index) => {
      this.form.addControl('visaFeesAndTerms_'+index, this.formBuilder.control(this.cart.currentApplication.visaFeesAndTerms || '', [Validators.requiredTrue]));
      if(!isPortOnlinePayable(this.request, _request) && this.api.env.useGuichet) {
        const ctrlName = 'payOnArrival';
        const initial = !!(this.cart.currentApplication[ctrlName] ?? this.cart.currentApplication.payOnArrival);
        this.form.addControl(ctrlName, this.formBuilder.control(initial, [Validators.requiredTrue]));
      }
      const requestReasonValue = this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REQUEST_REASON, _request.formConfig);
      if(requestReasonValue === 'NEW_REQUEST') {
        this.form.addControl('notHolderOfDocument_'+index, this.formBuilder.control(this.cart.currentApplication.notHolderOfDocument || '', [Validators.requiredTrue]));
      }
    });

    if(this.api.env.showresidentCardPenaltyInSummaryPage) {
      this.form.addControl('residentCardPenalty', this.formBuilder.control(this.cart.currentApplication.residentCardPenalty || '', [Validators.requiredTrue]));
    }

    if((this.showPayOnline || isPortOnlinePayable(this.request, this.cart.currentRequest)) && !this.api.userRole.isKiosk && !this.api.userRole.isWorker) {
      if(this.api.env.paymentChoiceType){
        this.form.addControl('payOnline', this.formBuilder.control(this.cart.currentApplication.payOnline || '', [Validators.required]));
      } else if(isPortOnlinePayable(this.request, this.cart.currentRequest)){
        this.cart.currentApplication.payOnline = 'true';
      }
    }
    if(((this.currentApplication.isExtend ? this.isExtendPayable() : this.getTotalPriceNr(true) > 0) || isPortOnlinePayable(this.request, this.cart.currentRequest)) && !this.api.userRole.isWorker && !this.api.userRole.isKiosk) {
      this.form.addControl('paymentMethod', this.formBuilder.control(this.cart.currentApplication.paymentMethod || '', [Validators.required]));
    }
  }

  submit() {
    this.submitted = true;

    if(this.forms.getFormErrors(this.form).length < 1) {

      const action = () => {
        this.disabledConfirm = true;
        if(this.scanDoc?.scanned) {
          this.keepScanned = true;
          this.scanDoc.visaDatas = [];
          sessionStorage.removeItem('visaDatas');
        }
        this.cart.currentApplication.visaFeesAndTerms = true;
        this.cart.saveCurrentApplication(false);
        if(this.cart.currentApplication.paymentMethod === RequestMNTAType.ZIMSWITCH) {
          this.disabledConfirm = false;
          this.submitted = false;
        }
        return this.request.pay(this.currentApplication.isExtend && this.api.userRole.isCustomer ? true : this.cart.currentApplication.payOnline === 'true').catch((err) => {
          this.disabledConfirm = false;
          this.loader.loading(true, {type: 'error', message: err}).then(() => {
            if(this.api.userRole.isCustomer && err.includes(this.lang.transform('client.extended.noValidPerson'))) {
              return this.api.persons().then((res) => {
                this.api.listPersons = this.request.getPersonsWithReviewStatus(res);
                this.cart.deleteSavedApplication(false);
                this.nav.to('people');
              });
            } else {
              return;
            }
          });
        });
      };

      if(!this.api.env.useGuichet && (this.currentApplication?.requests?.some(request => showWarning(request, this.request, this.cart)))) {
        const names = this.currentApplication.requests.filter(request => isCanHaveOnArrival({countryCat: setCurrentCountryCat({indexed: {Nationality: request.nationality}})}))
          .map(request => {
            const days = this.request.usageUntilFromNowDays(request);
            return days > 0
              ? `${request.person.firstName} ${request.person.lastName} (${days} ${this.lang.transform('days')})`
              : `${request.person.firstName} ${request.person.lastName}`;
          }).join(', ');
        this.loader.loading(true, {type: 'warn', custom: {innerHtml: this.lang.transform('summary.warning_validity_list', {names})}, btnLabel: 'understand'}).then((done: boolean) => {
          if(done) {
            action().then((res) => {
              if((res?.id || res?.ids) && this.api.env.formHasBookTimeSlotStep) {
                this.api.payment(res?.id || res?.ids[0]).then((request) => {
                  this.bookTimeSlot(res, request.usageUntil);
                });
              }
            });
          }
        });
      } else {
        action().then((res) => {
          if(res && this.api.env.formHasBookTimeSlotStep) {
            this.api.payment(res?.id || res?.ids[0]).then((request) => {
              this.bookTimeSlot(res, request.usageUntil);
            });
          }
        });
      }
    } else {
      this.disabledConfirm = false;
    }
  }

  bookTimeSlot(data: Payment, usageUntil: string) {
    this.disabledConfirm = true;
    const placeId = this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig)
    || this.request.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig)
    || this.request.getFieldValue(VisaFormName.APPLIER_INFORMATION, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig)
    || this.request.getFieldValue(VisaFormName.VISITOR_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig);
    this.dialog.openDialog(DialogBookTimeSlotComponent, 'lg', {payment: data, placeId: placeId, usageUntil: usageUntil}, true, undefined, true).then((res: Payment) => {
      this.loader.loading(false);
      if(res && res.body?.checkoutUrl) {
        window.location.href = res.body.checkoutUrl;
      } else if(res && res.ids) {
        // Submits IVERI form / opens ZimSwitch dialog / returns a payment id only when no redirect is needed
        const paymentId = this.request.processPaymentResponse(this.cart.currentApplication.paymentMethod as RequestMNTAType, data);
        if(paymentId) {
          this.nav.to('payment-success');
        }
      } else {
        this.disabledConfirm = false;
        this.loader.loading(false);
        //Generate new travelName
        this.cart.currentApplication.travelName = this.cart.getUniqueReference(this.request.allMyPayments?.map(p => p.batchId) || [], 6);
        this.cart.saveCurrentApplication(true);
      }
    });
  }

  getConfigFields(req: Request): FormField[] {
    let fields = Object.values(req.formConfig).flatMap((step: FormStep) => step.fields);
    //filter fields that only have value in the form
    fields = fields.filter((field: FormField) => field.value !== undefined && field.value !== null && field.value !== '');

    if(req.passportType) {
      fields = fields.map((field: FormField) => ({...field, name: field.name === VisaFN.PASSPORT_NUMBER ? ('PassportNumber') : field.name}));
    }

    fields = fields.map((field: FormField) => ({...field, value: field.name === VisaFN.PASSPORT_URGENT_DELIVERY ||
      field.name === VisaFN.MARITAL_STATUS ||
      field.name === VisaFN.PASSPORT_TYPE ||
      field.name === VisaFN.PARENT_GUARDIAN_CONSENT ? field.value.toLowerCase() : field.value}));

    fields = fields.map((field: FormField) => ({...field, value: field.name === VisaFN.NATIONALITY ||
      field.name === VisaFN.PASSPORT_COUNTRY ||
      field.name === VisaFN.PASSPORT_TYPE ||
      field.name === VisaFN.RESIDENT_PERMIT_TYPE ||
      field.name === VisaFN.HAIR_COLOR ||
      field.name === VisaFN.EYE_COLOR ||
      field.name === VisaFN.MARITAL_STATUS ||
      field.name === VisaFN.MODE_OF_TRAVEL ||
      field.name === VisaFN.REGISTRATION_TYPE ||
      field.name === VisaFN.COUNTRY_OF_RESIDENCE ||
      field.name === VisaFN.COUNTRY_OF_BIRTH ||
      field.name === VisaFN.PLACE_OF_BIRTH ||
      field.name === VisaFN.SECOND_NATIONALITY ||
      field.name === VisaFN.PLACE_OF_BIRTH_COUNTRY ? field.value : field.value}));

    fields = fields.map((field: FormField) => ({
      ...field, value:
      field.name === VisaFN.IDENTIFICATION_DOCUMENT ||
      field.name === VisaFN.GUARDIAN_IDENTIFICATION_DOCUMENT ||
      field.name === VisaFN.GUARDIAN_MANAGER_IDENTIFICATION_DOCUMENT ||
      field.name === VisaFN.RELATIONSHIP ||
      field.name === VisaFN.REQUEST_REASON ||
      field.name === VisaFN.REGISTRATION_TYPE ||
      field.name === VisaFN.ATTESTANT_RELATION ||
      field.name === VisaFN.STATUS ||
      field.name === VisaFN.MANAGER_JOB_TITLE ||
      field.name === VisaFN.GENDER
        ? 'DYN.' + field.value
        : field.value
    }));

    return fields;
  }

  getPrice(request: Request, onlyNum = false, onlyAmount = false) {
    if(!request) return;
    if(!this.api.env.useGuichet){
      if(this.cart.currentApplication.isRevision) return 0;
      const document = this.api.userInfo.server.paymentRequests.find(p => p.id === request.visaType.id);
      if(onlyNum) return document.amountCents > 0;
      if(this.cart.currentApplication?.isExtend) {
        const baseExtensionPrice = Math.floor((document.amountCentsDyn ?
          eval(document.amountCentsDyn)({
            DaysRequested: this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.DAYS_REQUESTED, this.cart.currentApplication.requests[0].formConfig)
          }, this.api.userPlace) : document.amountCents) / 100);
        const parentRequest = this.cart.currentApplication?.parentRequest;
        const isOverstay = this.request.isOverstay(parentRequest);
        const overstayPrice = isOverstay ? this.api.userInfo.server.paymentNonDocumentsCents.overstay / 100 : 0;
        const totalPrice = baseExtensionPrice + overstayPrice; // Check for overstay and add penalty if applicable
        return (onlyAmount ? '' : document.currency + ' ') + totalPrice;
      } else {
        return (onlyAmount ? '' : document.currency + ' ') + Math.floor((document.amountCentsDyn ?
          eval(document.amountCentsDyn)({
            Nationality: request.nationality,
            Urgent: request.urgent
          }, this.api.userPlace) : document.amountCents) / 100);
      }
    } else {
      const document = this.api.userInfo.server.paymentRequests.find(p => p.id === request.visaType.id);
      let amountCents = document.amountCents;
      if(document.amountCentsDyn) {
        amountCents = eval(document.amountCentsDyn)({
          RegistrationPortId: this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig) || this.request.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig)});
      }

      let currency = document.currency;
      if(document.currencyDyn) {
        currency = eval(document.currencyDyn)({
          RegistrationPortId: this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig) || this.request.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.cart.currentApplication.requests[0].formConfig)});
      }

      const price = Math.floor((amountCents || 0) / 100);
      if(onlyAmount) return price;

      return currency + ' ' + price;
    }
  }

  getCurrency(): string {
    const req = this.currentApplication?.requests?.[0];
    if(!req) return '';

    const document = this.api.userInfo.server.paymentRequests.find(p => p.id === req.visaType.id);
    if(!document) return '';

    let currency = document.currency;
    if(document.currencyDyn) {
      const registrationPortId = this.request.getFieldValue(VisaFormName.PERSONAL_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.currentApplication.requests[0].formConfig) || this.request.getFieldValue(VisaFormName.MISCELLANEOUS_DETAILS, VisaFN.REGISTRATION_PORT_ID, this.currentApplication.requests[0].formConfig);
      currency = eval(document.currencyDyn)({RegistrationPortId: registrationPortId});
    }

    return currency;
  }

  getError(formControlName: string): FormError[] {
    return this.forms.getFormErrors(this.form, formControlName, false).map((error: FormError) => {
      error.key = error.key.split('_')[0];
      return error;
    });
  }

  getCombinedErrorsFor(controlNames: string[]): FormError[] {
    if(!this.form) return [];
    const foundErrors = controlNames.flatMap(name => {
      const ctrl = this.form.get(name);
      return ctrl ? (this.forms.getFormErrors(this.form, name, false) || []) : [];
    }).filter(Boolean);
    if(foundErrors.length) {
      return [{
        key: 'summary.accept.all',
        keyError: 'summary.accept.all',
        control: controlNames.join('|')
      } as FormError];
    }
    return [];
  }

  checkPayOnline($event: any) {
    this.cart.currentApplication.payOnline= $event;
    if($event === 'true') {
      this.showModalityMessage = false;
      if(!this.form.controls.paymentMethod) {
        this.form.addControl('paymentMethod', this.formBuilder.control('', [Validators.required]));
      }
      if(this.getTotalPriceNr(true) <= 0) {
        this.cart.currentApplication.paymentMethod = undefined;
        this.cart.currentApplication.cardSelected = undefined;
        if(this.form.controls.paymentMethod) {
          this.form.removeControl('paymentMethod');
        }
      }
    } else {
      this.showModalityMessage = true;
      if(this.getTotalPriceNr(true) <= 0 || this.isPortOnlinePayable(this.request, this.cart.currentRequest)) {
        this.cart.currentApplication.paymentMethod = undefined;
        this.cart.currentApplication.cardSelected = undefined;
        if(this.form.controls.paymentMethod) {
          this.form.removeControl('paymentMethod');
        }
      }
    }
    this.cart.saveCurrentApplication(false);
  }

  getTotalPrice(onlyAmount = false, toPayOnline: boolean): string | number {
    let totalOnline = 0;
    let totalOffline = 0;
    const document = this.api.userInfo.server.paymentRequests.find(p => p.id === this.currentApplication.requests[0].visaType.id);
    this.currentApplication.requests.forEach(request => {
      const price = this.getPrice(request, false, true);
      if(this.request.isPaidOnline(request.visaType.id, request.metadata, request)) {
        totalOnline = Number(totalOnline) + Number(price);
      } else {
        totalOffline = Number(totalOffline) + Number(price);
      }

    });
    if(toPayOnline) {
      if(onlyAmount) {
        if(this.cart.currentApplication.payOnline === 'true') return totalOnline + totalOffline;
        return totalOnline;
      } else {
        if(this.cart.currentApplication.payOnline === 'true') return document.currency + ' ' + (totalOnline + totalOffline);
        return totalOnline ? document.currency + ' ' + totalOnline : '';
      }
    } else {
      if(onlyAmount) {
        return totalOffline;
      } else {
        return totalOffline ? document.currency + ' ' + totalOffline : '';
      }
    }
  }

  getTotalPriceNr(b: boolean): number {
    return this.getTotalPrice(true, b) as number;
  }

  previous() {
    if(this.scanDoc?.scanned) {
      this.keepScanned = true;
    }
    this.nav.to('form-visa', undefined, {queryParams: {direction: Direction.PREVIOUS}});
  }

  getPersons(requests: Request[]) {
    const requestsPersons = requests.map(request => request.person);
    const persons = this.api.listPersons.filter(person => requestsPersons.some(requestPerson => requestPerson.id === person.id));
    return persons.map(person => person.firstName + ' ' + person.lastName).join(', ');
  }

  getTranslateCompleted(requests: Request[]) {
    const requestsPersons = requests.map(request => request.person);
    const persons = this.api.listPersons.filter(person => requestsPersons.some(requestPerson => requestPerson.id === person.id));
    return this.lang.transform('completedApplications', {persons: persons.map(person => person.firstName + ' ' + person.lastName).join(', ')});
  }

  changePaymentMethode($event: any) {
    this.cart.currentApplication.cardSelected = $event;
    if(Object.values(IveriCards).includes($event) && this.api.env.supportedPaymentProviders.includes(RequestMNTAType.IVERI)) {
      this.cart.currentApplication.paymentMethod = RequestMNTAType.IVERI;
    } else if(Object.values(ZimSwitchCards).includes($event) && this.api.env.supportedPaymentProviders.includes(RequestMNTAType.ZIMSWITCH)) {
      this.cart.currentApplication.paymentMethod = RequestMNTAType.ZIMSWITCH;
      this.cart.saveCurrentApplication(false);
    } else if(Object.values(PaypalCards).includes($event) && this.api.env.supportedPaymentProviders.includes(RequestMNTAType.PAYPAL)) {
      this.cart.currentApplication.paymentMethod = RequestMNTAType.PAYPAL;
    }
  }

  isExtendPayable(): boolean {
    const isExtend = this.currentApplication?.isExtend;
    if(!isExtend) return false;
    const request = this.currentApplication.requests?.[0];
    if(!request) return false;
    const amountExtend = this.getPrice(request, false, true);
    return Number(amountExtend) > 0;
  }

  detectIfDraftPayments(): Promise<void> {
    const existingPayments = this?.request.allMyPayments.filter(payment => payment.batchId === this.cart.currentApplication.travelName);
    const existingDraftPayment = existingPayments?.filter(payment => payment.state === RequestState.PROPOSED);
    if(existingDraftPayment.length) {
      return this.loader.loading(true, {type: 'warn', custom: {innerHtml: this.lang.transform('existing.draftPayment')}, btnLabel: 'continue'}).then((done: boolean) => {
        if(done){
          return this.payment.cleanupExistingPayments(false);
        } else {
          return this.nav.to('dashboard');
        }
      });
    } else if(!existingPayments.length) {
      //If there is no draft payment with the same travel name, generate a new one
      this.cart.currentApplication.travelName = this.cart.getUniqueReference(this.request.allMyPayments?.map(p => p.batchId) || [], 6);
      this.cart.saveCurrentApplication(false);
    }
  }

  showTermsAndConditions(event?: any): void {
    if (this.api.env.showFullTermsAndConditions && event?.checked) {
      this.loader.loading(true, {
        type: 'info',
        custom: {
          innerHtml: this.lang.transform('summary.terms.fullContent'),
          icon: 'file-contract'
        }
      });
    }
  }

  protected readonly VisaFN = VisaFN;
  protected readonly CurrencySign = CurrencySign;
  protected readonly VisaFormName = VisaFormName;
  protected readonly RequestMNTAType = RequestMNTAType;
  protected readonly DocumentType = DocumentType;
}
